import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RosterFilterQuery, RosterSearchQuery, RosterSortConfig, RosterState } from "../roster-types";

const initialState: RosterState = {
	searchQuery: {},
	filterQuery: {
		role: [],
		locked: [],
	},
	sortConfigs: [],
	currentPage: 0,
	pageSize: 8,
};

export const rosterSlice = createSlice({
	name: "roster",
	initialState,
	reducers: {
		setSearchQuery: (state, action: PayloadAction<RosterSearchQuery>) => {
			state.searchQuery = action.payload;
			state.currentPage = 0;
		},
		setFilters: (state, action: PayloadAction<RosterFilterQuery>) => {
			state.filterQuery = action.payload;
			state.currentPage = 0;
		},
		setCurrentPage: (state, action: PayloadAction<number>) => {
			state.currentPage = action.payload;
		},
		setPageSize: (state, action: PayloadAction<number>) => {
			state.pageSize = action.payload;
			state.currentPage = 0;
		},
		setSortConfigs: (state, action: PayloadAction<RosterSortConfig[]>) => {
			state.sortConfigs = action.payload;
			state.currentPage = 0;
		},
	},
});

export const { setSearchQuery, setFilters, setCurrentPage, setPageSize, setSortConfigs } = rosterSlice.actions;

export default rosterSlice.reducer;
